import { Component, OnInit } from '@angular/core';
import { CoreService } from '@app/modules/core/services/core.service';
import { QrGeneratorNavigatorCategories } from 'shared-library';
import { QrGeneratorNavigator } from '@app/store/models/qr-generator-navigator.interface';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-shared-qr-preview-wifi',
  templateUrl: './shared-qr-preview-wifi.component.html',
  styleUrls: ['./shared-qr-preview-wifi.component.scss']
})
export class SharedQrPreviewWifiComponent implements OnInit {

  create_mode = !window.location.href.includes("edit")

  session_info: SessionInfo
  data: QrGeneratorNavigator
  private subscriptions: Subscription[] = []

  constructor(private coreService: CoreService) {
    this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => {
      this.session_info = si
      if (this.create_mode) {
        this.data = this.session_info?.qr_generating?.drafts?.find(d => d.selected_category === QrGeneratorNavigatorCategories.WIFI)
      } else {
        this.data = this.session_info?.qr_generating?.updating
      }
    }))
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe())
  }



}
